import { createGlobalStyle, css } from 'styled-components';
const FormVariables = createGlobalStyle `${css `
	:root {
		//! Fonts
		--form_Font: ${(props) => css `var(--${props.fontFamily})`};

		//! Transition
		--form_trTime: 0.2s;

		//! Line Height
		--form_lineHeight: 1.5;

		//! Box Shadow
		--form_boxShadowColor: ${(props) => props.theme.form.colors.boxShadowColor};

		//! Empty Text Color
		--form_emptyTextColor: ${(props) => props.theme.form.colors.emptyTextColor};

		//! Message colors
		--form_errorMessageColor: ${(props) => props.theme.form.colors.errorMessageColor};
		--form_errorMessageBorderColor: ${(props) => props.theme.form.colors.errorMessageBorderColor};
		--form_errorMessageBgColor: ${(props) => props.theme.form.colors.errorMessageBgColor};
		--form_successMessageColor: ${(props) => props.theme.form.colors.successMessageColor};
		--form_successMessageBorderColor: ${(props) => props.theme.form.colors.successMessageBorderColor};
		--form_successMessageBgColor: ${(props) => props.theme.form.colors.successMessageBgColor};

		/* //! Label */
		--form_labelColor: ${(props) => props.theme.form.colors.labelColor};
		--form_labelHoverColor: ${(props) => props.theme.form.colors.labelHoverColor};
		--form_labelFocusColor: ${(props) => props.theme.form.colors.labelFocusColor};
		--form_labelActiveColor: ${(props) => props.theme.form.colors.labelActiveColor};
		--form_labelErrorColor: ${(props) => props.theme.form.colors.labelErrorColor};
		--form_labelDisabledColor: ${(props) => props.theme.form.colors.labelDisabledColor};

		/* //! Input */
		--form_inputColor: ${(props) => props.theme.form.colors.inputColor};
		--form_inputHoverColor: ${(props) => props.theme.form.colors.inputHoverColor};
		--form_inputFocusColor: ${(props) => props.theme.form.colors.inputFocusColor};
		--form_inputActiveColor: ${(props) => props.theme.form.colors.inputActiveColor};
		--form_inputErrorColor: ${(props) => props.theme.form.colors.inputErrorColor};
		--form_inputDisabledColor: ${(props) => props.theme.form.colors.inputDisabledColor};

		--form_inputPlaceholderColor: ${(props) => props.theme.form.colors.inputPlaceholderColor};
		--form_inputPlaceholderHoverColor: ${(props) => props.theme.form.colors.inputPlaceholderHoverColor};
		--form_inputPlaceholderFocusColor: ${(props) => props.theme.form.colors.inputPlaceholderFocusColor};
		--form_inputPlaceholderActiveColor: ${(props) => props.theme.form.colors.inputPlaceholderActiveColor};
		--form_inputPlaceholderErrorColor: ${(props) => props.theme.form.colors.inputPlaceholderErrorColor};
		--form_inputPlaceholderDisabledColor: ${(props) => props.theme.form.colors.inputPlaceholderDisabledColor};

		--form_inputBorderColor: ${(props) => props.theme.form.colors.inputBorderColor};
		--form_inputBorderHoverColor: ${(props) => props.theme.form.colors.inputBorderHoverColor};
		--form_inputBorderFocusColor: ${(props) => props.theme.form.colors.inputBorderFocusColor};
		--form_inputBorderActiveColor: ${(props) => props.theme.form.colors.inputBorderActiveColor};
		--form_inputBorderErrorColor: ${(props) => props.theme.form.colors.inputBorderErrorColor};
		--form_inputBorderDisabledColor: ${(props) => props.theme.form.colors.inputBorderDisabledColor};

		--form_inputBgColor: ${(props) => props.theme.form.colors.inputBgColor};
		--form_inputHoverBgColor: ${(props) => props.theme.form.colors.inputHoverBgColor};
		--form_inputFocusBgColor: ${(props) => props.theme.form.colors.inputFocusBgColor};
		--form_inputActiveBgColor: ${(props) => props.theme.form.colors.inputActiveBgColor};
		--form_inputErrorBgColor: ${(props) => props.theme.form.colors.inputErrorBgColor};
		--form_inputDisabledBgColor: ${(props) => props.theme.form.colors.inputDisabledBgColor};

		/* //! Select */
		--form_selectColor: ${(props) => props.theme.form.colors.selectColor};
		--form_selectHoverColor: ${(props) => props.theme.form.colors.selectHoverColor};
		--form_selectFocusColor: ${(props) => props.theme.form.colors.selectFocusColor};
		--form_selectActiveColor: ${(props) => props.theme.form.colors.selectActiveColor};
		--form_selectErrorColor: ${(props) => props.theme.form.colors.selectErrorColor};
		--form_selectDisabledColor: ${(props) => props.theme.form.colors.selectDisabledColor};

		--form_selectPlaceholderColor: ${(props) => props.theme.form.colors.selectPlaceholderColor};
		--form_selectPlaceholderHoverColor: ${(props) => props.theme.form.colors.selectPlaceholderHoverColor};
		--form_selectPlaceholderFocusColor: ${(props) => props.theme.form.colors.selectPlaceholderFocusColor};
		--form_selectPlaceholderActiveColor: ${(props) => props.theme.form.colors.selectPlaceholderActiveColor};
		--form_selectPlaceholderErrorColor: ${(props) => props.theme.form.colors.selectPlaceholderErrorColor};
		--form_selectPlaceholderDisabledColor: ${(props) => props.theme.form.colors.selectPlaceholderDisabledColor};

		--form_selectBorderColor: ${(props) => props.theme.form.colors.selectBorderColor};
		--form_selectBorderHoverColor: ${(props) => props.theme.form.colors.selectBorderHoverColor};
		--form_selectBorderFocusColor: ${(props) => props.theme.form.colors.selectBorderFocusColor};
		--form_selectBorderActiveColor: ${(props) => props.theme.form.colors.selectBorderActiveColor};
		--form_selectBorderErrorColor: ${(props) => props.theme.form.colors.selectBorderErrorColor};
		--form_selectBorderDisabledColor: ${(props) => props.theme.form.colors.selectBorderDisabledColor};

		--form_selectBgColor: ${(props) => props.theme.form.colors.selectBgColor};
		--form_selectHoverBgColor: ${(props) => props.theme.form.colors.selectHoverBgColor};
		--form_selectFocusBgColor: ${(props) => props.theme.form.colors.selectFocusBgColor};
		--form_selectActiveBgColor: ${(props) => props.theme.form.colors.selectActiveBgColor};
		--form_selectErrorBgColor: ${(props) => props.theme.form.colors.selectErrorBgColor};
		--form_selectDisabledBgColor: ${(props) => props.theme.form.colors.selectDisabledBgColor};

		--form_selectOptionColor: ${(props) => props.theme.form.colors.selectOptionColor};
		--form_selectOptionHoverColor: ${(props) => props.theme.form.colors.selectOptionHoverColor};
		--form_selectOptionFocusColor: ${(props) => props.theme.form.colors.selectOptionFocusColor};
		--form_selectOptionActiveColor: ${(props) => props.theme.form.colors.selectOptionActiveColor};
		--form_selectOptionErrorColor: ${(props) => props.theme.form.colors.selectOptionErrorColor};
		--form_selectOptionDisabledColor: ${(props) => props.theme.form.colors.selectOptionDisabledColor};

		--form_selectOptionBgColor: ${(props) => props.theme.form.colors.selectOptionBgColor};
		--form_selectOptionHoverBgColor: ${(props) => props.theme.form.colors.selectOptionHoverBgColor};
		--form_selectOptionFocusBgColor: ${(props) => props.theme.form.colors.selectOptionFocusBgColor};
		--form_selectOptionActiveBgColor: ${(props) => props.theme.form.colors.selectOptionActiveBgColor};
		--form_selectOptionErrorBgColor: ${(props) => props.theme.form.colors.selectOptionErrorBgColor};
		--form_selectOptionDisabledBgColor: ${(props) => props.theme.form.colors.selectOptionDisabledBgColor};

		/* //! Radio */
		--form_radioBorderColor: ${(props) => props.theme.form.colors.radioBorderColor};
		--form_radioBorderActiveColor: ${(props) => props.theme.form.colors.radioBorderActiveColor};
		--form_radioBgColor: ${(props) => props.theme.form.colors.radioBgColor};
		--form_radioActiveBgColor: ${(props) => props.theme.form.colors.radioActiveBgColor};

		/* //! Upload */
		--form_uploadBgColor: ${(props) => props.theme.form.colors.uploadBgColor};
		--form_uploadBorderColor: ${(props) => props.theme.form.colors.uploadBorderColor};
	}

	/* //! 2560 */
	@media only screen and (min-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeXL}) {
		:root {
			--form_p1: 32px;
			--form_p2: 24px;
			--form_p3: 20px;
			--form_p4: 18px;
			--form_p5: 12px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp4x);
			--form_errorItemMTop: var(--sp1-5x);
			--form_globalErrorWrapMarTB: var(--sp7x);
		}
	}

	/* //! 2559 - 1920 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeL}) {
		:root {
			--form_p1: 24px;
			--form_p2: 20px;
			--form_p3: 16px;
			--form_p4: 16px;
			--form_p5: 10px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp3x);
			--form_errorItemMTop: var(--sp1x);
			--form_globalErrorWrapMarTB: var(--sp5x);
		}
	}

	/* //! 1919 - 1510 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeLMin}) and (min-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeM}) {
		:root {
			--form_p1: 20px;
			--form_p2: 18px;
			--form_p3: 16px;
			--form_p4: 14px;
			--form_p5: 10px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp2-5x);
			--form_errorItemMTop: var(--sp1-5x);
			--form_globalErrorWrapMarTB: var(--sp4x);
		}
	}

	/* //! 1509 - 1440 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeMMin}) and (min-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeS}) {
		:root {
			--form_p1: 20px;
			--form_p2: 18px;
			--form_p3: 16px;
			--form_p4: 14px;
			--form_p5: 10px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp2x);
			--form_errorItemMTop: var(--sp0-5x);
			--form_globalErrorWrapMarTB: var(--sp4x);
		}
	}

	/* //! 1439 - 1280 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeSMin}) and (min-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeXS}) {
		:root {
			--form_p1: 20px;
			--form_p2: 16px;
			--form_p3: 16px;
			--form_p4: 12px;
			--form_p5: 8px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp2x);
			--form_errorItemMTop: var(--sp1x);
			--form_globalErrorWrapMarTB: var(--sp3x);
		}
	}

	/* //! 1279 - 1024 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.form.mediaQuery.form_TabletSize}) {
		:root {
			--form_p1: 18px;
			--form_p2: 16px;
			--form_p3: 16px;
			--form_p4: 12px;
			--form_p5: 8px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp2x);
			--form_errorItemMTop: var(--sp1x);
			--form_globalErrorWrapMarTB: var(--sp3x);
		}
	}

	/* //! 1023 - 768 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_TabletSizeMin}) and (min-width: ${(props) => props.theme.form.mediaQuery.form_TabletSizeS}) {
		:root {
			--form_p1: 18px;
			--form_p2: 16px;
			--form_p3: 16px;
			--form_p4: 12px;
			--form_p5: 8px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp2x);
			--form_errorItemMTop: var(--sp1x);
			--form_globalErrorWrapMarTB: var(--sp3x);
		}
	}

	/* //! 767 */
	@media only screen and (max-width: ${(props) => props.theme.form.mediaQuery.form_TabletSizeSMin}) {
		:root {
			--form_p1: 16px;
			--form_p2: 16px;
			--form_p3: 16px;
			--form_p4: 12px;
			--form_p5: 8px;

			//! Global error sizes
			--form_globalErrorPad: var(--sp2x);
			--form_errorItemMTop: var(--sp1x);
			--form_globalErrorWrapMarTB: var(--sp3x);
		}
	}
`}`;
export default FormVariables;
//# sourceMappingURL=variables.js.map